'use client';

import NumberField from '@koda/koda-components/molecules/NumberField';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import { CHURCH_CONTENT_PATH, churchSchema, createChurchDefaults } from './church.Schema';

function ChurchComponent(): ReactElement {
  const licenseCode = LicenseTypes.Church;

  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: churchSchema,
    defaults: createChurchDefaults,
  });

  const t = useTranslations(CHURCH_CONTENT_PATH);

  return (
    <>
      <NumberField
        label={t('numberOfEventsPerYear.label')}
        name="numberOfEventsPerYear"
        placeholder={t('numberOfEventsPerYear.placeholder')}
        required
        disabled={costCalculated}
        value={values.numberOfEventsPerYear}
        onChange={e => setField('numberOfEventsPerYear', parseInt(e.target.value))}
        error={showErrors ? getError('numberOfEventsPerYear') : undefined}
        validated={!!values.numberOfEventsPerYear && !getError('numberOfEventsPerYear')}
        helpText={t('numberOfEventsPerYear.helpText')}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
    </>
  );
}

export default ChurchComponent;
